export default __webpack_public_path__ + "static/media/nouns-ios.529e2cef.gif";